import {axios, API, SendRequest} from '@/imports-files/pages/clients/jobs/automations';

export class Automation extends SendRequest {

  async getJobStagesList(jobId) 
  {
    try {
      const result = await axios.get( API.client.jobs.JOB_STAGES_LIST.replace('$job_id', jobId),
          {
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getVideoInterviewPlatforms() {
    try {
      const result = await axios.get( API.client.jobs.VIDEO_PLATFORMS,
          {
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }


  async setThreshold(params, jobId, jobStageId){
    try {
      const result = await axios.patch(API.client.jobs.UPDATE_THRESHOLD.replace('$job_id', jobId).replace('$job_stage_id', jobStageId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
  
  async updateAutomations(params, jobId)
  {
    try {
      const result = await axios.post(API.client.jobs.UPDATE_AUTOMATIONS.replace('$job_id', jobId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async addAutomations(params, jobId, jobStageId)
  {
    try {
      const result = await axios.post(API.client.jobs.ADD_AUTOMATIONS.replace('$job_id', jobId).replace('$job_stage_id', jobStageId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }


  async jobStageData(jobId, jobStageId) {
    try {
      const result = await axios.get(API.client.jobs.JOB_STAGE_DATA.replace('$job_id', jobId).replace('$job_stage_id', jobStageId),
          {
            params: {}, 
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async manualJobStageData(jobId, jobStageId) {
    try {
      const result = await axios.get(API.client.jobs.MANUAL_JOB_STAGE_DATA,
          {
            params: {job_stage_id: jobStageId},
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getTechTests(value){
    try {
      const result = await axios.get(API.client.jobs.GET_TECH_TESTS,
          {
            params: {search_text: value, type: 'TestLibrary'},
            headers: this.customHeaderJSON() 
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
     return hash;
    } catch (error) {
      return error;
    }
  }

  async getAssessmentTests(value){
    try {
      const result = await axios.get(API.client.jobs.GET_TECH_TESTS,
          {
            params: {search_text: value, type: 'Assessment'},
            headers: this.customHeaderJSON() 
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
     return hash;
    } catch (error) {
      return error;
    }
  }


  async addTechTests(params, jobId, jobStageId)
  {
    try {
      const result = await axios.post(API.client.jobs.ADD_TECH_TESTS.replace('$job_id', jobId).replace('$job_stage_id', jobStageId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

}